module.exports = __webpack_public_path__ + "img/human_84.59fb714c.png";